var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("BarreFiltres", {
        attrs: { filtres: _vm.filtres },
        on: {
          "appliquer-filtre": function($event) {
            return _vm.appliquerFiltre($event)
          }
        }
      }),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-center-center" }, [
      _c(
        "div",
        { staticClass: "card col-12 col-xl-10 col-xxl-8 height-responsive" },
        [
          _c("div", { staticClass: "card-header" }, [
            _vm._v(" Productions - Documentation ")
          ]),
          _c(
            "div",
            {
              staticClass:
                "card-container height-responsive-body height-responsive-1b"
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c("p", [
                  _vm._v(
                    "Une production permet de générer 3 documents principaux utiles pour la mise en production des recettes, la gestion du stock et la livraison des recettes si besoin."
                  ),
                  _c("br"),
                  _c("ul", { staticClass: "puces" }, [
                    _c("li", [
                      _c("b", [_vm._v("Fiche de production")]),
                      _vm._v(
                        " : indique pour chaque recette les quantités d'ingrédients nécessaires pour le nombre d'effectifs paramétré sur le menu. En fonction du paramétrage du barquettage et du portage, ce fichier indique également la quantité de barquette à prévoir pour la recette."
                      )
                    ]),
                    _c("li", [
                      _c("b", [_vm._v("Fiche de sortie")]),
                      _vm._v(
                        " : indique la quantité d'ingrédient à sortir de votre stock pour la production des recettes."
                      )
                    ]),
                    _c("li", [
                      _c("b", [_vm._v("Bon de livraison")]),
                      _vm._v(
                        " : indique les recettes à livrer sur vos lieux de portage, indique également la quantité de barquettes à livrer en fonction du paramétrage."
                      )
                    ])
                  ])
                ]),
                _c("p", [
                  _vm._v("Elle génère également d'autres documents : "),
                  _c("ul", { staticClass: "puces" }, [
                    _c("li", [
                      _c("b", [_vm._v("Sortie de production")]),
                      _vm._v(
                        " : indique les quantités de produits à sortir du stock."
                      )
                    ]),
                    _c("li", [
                      _c("b", [_vm._v("Relevé de température")]),
                      _vm._v(
                        " : pour suivre les températures de chaque recette."
                      )
                    ]),
                    _c("li", [
                      _c("b", [_vm._v("Refroidissement")]),
                      _vm._v(
                        " : pour suivre l'étape de refroidissement de chaque recette."
                      )
                    ]),
                    _c("li", [
                      _c("b", [_vm._v("Etiquettes")]),
                      _vm._v(
                        " : pages d'étiquettes au format 99.1 x 38.1 mm, 14 étiquettes par page, pour étiquetter les barquettes de portages."
                      )
                    ]),
                    _c("li", [
                      _c("b", [_vm._v("Récapitulatif d'allotissement")]),
                      _vm._v(
                        " : indique pour chaque recette le nombre d'effectifs par lieu de portage"
                      )
                    ])
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionConfiguration" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Configuration des productions")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/production/configuration/configurationProduction.png"),
                        alt: "Configuration production"
                      }
                    })
                  ]),
                  _c("p", [
                    _vm._v(
                      "Sur cette page vous pouvez définir des informations et options pour les fichiers générés pour vos producitons."
                    )
                  ]),
                  _c("ul", { staticClass: "puces" }, [
                    _c("li", [
                      _vm._v(
                        "Agrément Sanitaire : nécessaire pour effectuer du portage"
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "DLC : nombre de jours limite de consommation après la production"
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Répartition par lieu de portage : indique sur la fiche de production le nombre d'effectifs par lieu de portage pour chaque recette. Soit en fin de fichier, soit sous chaque recette."
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Bons de livraison : options pour le fichier bon de livraison"
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Etiquettes : indique si le fichier des étiquettes doit etre généré. Si les barquettes sont configurées, il génère une étiquette par barquette, avec le nombre de portions de chaque recette. Sinon on indique le nombre d'effectifs par recette."
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        "Enregistrement du refroidissement : pour personnaliser le fichier de suivi de refroidissement."
                      )
                    ])
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionProduction" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Création d'une production")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      'Pour lancer une production, cliquez sur "Créer une mise en production".'
                    )
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/production/suivi/creationProduction1.png"),
                        alt: "Illustration page production"
                      }
                    })
                  ]),
                  _c("p", [
                    _vm._v(
                      "Si vous sélectionnez une période qui dispose d'un menu, celui-ci s'intégrera directement dans le champ 'structure de menus à inclure'. Vous avez ensuite la possibilité d'indiquer les services concernés."
                    )
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/production/suivi/creationProduction2.png"),
                        alt: "Illustration page production"
                      }
                    })
                  ]),
                  _c("p", [
                    _vm._v(
                      "Quand vous cliquez sur \"créer\", une fenêtre s'affiche pour que vous puissiez attribuer un nom à votre production ainsi qu'une DLC. "
                    )
                  ]),
                  _c("div", { staticClass: "flex-center-center mb-3" }, [
                    _c("div", { staticClass: "col-8" }, [
                      _c("img", {
                        staticClass: "border-black border-rounded w-100",
                        attrs: {
                          src: require("../../assets/images/documentation/production/suivi/fenetreCreationProduction.png"),
                          alt: "Illustration page production"
                        }
                      })
                    ])
                  ]),
                  _c("p", [
                    _vm._v(
                      'Elle sera répertoriée dans "Productions en cours". Cliquez dessus pour accéder à des options supplémentaires et suivez les étapes indiquées.'
                    )
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/production/suivi/etapeMiseEnProd.png"),
                        alt:
                          "Illustration des étapes pour la mise en production"
                      }
                    })
                  ]),
                  _c("p", [
                    _vm._v(
                      "Lorsque vous atteignez l'étape numéro 2, vous avez toujours la possibilité d'ajuster les effectifs en accédant à \"Menus - Suivi\". Une fois que vous avez saisi les nouveaux effectifs, effectuez le recalcul des documents pour les mettre à jour. "
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Vous pouvez choisir parmi différentes options d'exportation, soit en format PDF ou en Excel."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Si vous cliquez sur confirmer la sortie de stock, un message vous demande confirmation de la sortie de stock, correspondant à votre production"
                    )
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionSupression" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Suppression d'une production")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      "Une fois créée, vous pouvez supprimer une production. Pour cela, reportez-vous à la liste des productions en cours, cliquez sur celle que vous souhaitez supprimer."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "En bas de l'écran un champ s'affiche avec sur la gauche un bouton supprimer."
                    )
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/production/suivi/suppressionProduction.png"),
                        alt: "Illustration supression production"
                      }
                    })
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionPortage" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Gestion de vos lieux de portage")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      " Ici, vous pouvez gérer pour votre établissement des lieux de portages, sur lesquels vos productions peuvent être livrées."
                    ),
                    _c("br"),
                    _vm._v(
                      " Pour chacun des lieux de portage vous devez définir un effectif par défaut pour chaque structure / service de menu, ainsi que ses jours d'ouvertures."
                    ),
                    _c("br"),
                    _vm._v(
                      " La liste présente de façon synthétique les jours d'ouvertures et le nombre d'effectifs total à livrer sur le lieu de portage."
                    ),
                    _c("br"),
                    _vm._v(
                      ' Il est possible d\'afficher le détail des effectifs par structure/régime/texture en cochant la case "Détailler les catégories".'
                    ),
                    _c("br")
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/production/portage/listePortage.png"),
                        alt: "Illustration liste lieu de portage"
                      }
                    })
                  ]),
                  _c("p", [
                    _vm._v(
                      " La liste des lieux de portage peut etre triée à partir du bouton "
                    ),
                    _c("button", { staticClass: "btn btn-primary" }, [
                      _vm._v("Trier les lieux de portage")
                    ]),
                    _vm._v(
                      ". Il suffit de glisser déposer les lieux en fonction de l'ordre voulu."
                    ),
                    _c("br"),
                    _vm._v(
                      " Les jours d'ouvertures peuvent etre modifiés de facon générale à partir du bouton "
                    ),
                    _c("button", { staticClass: "btn btn-primary" }, [
                      _vm._v("Modifier les jours d'ouvertures")
                    ]),
                    _vm._v("."),
                    _c("br")
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionCreationPortage" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Paramétrage du lieu de portage")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      " Pour créer un nouveau lieu de portage, il suffit de cliquer sur le bouton "
                    ),
                    _c("button", { staticClass: "btn btn-primary" }, [
                      _vm._v("Ajouter un lieu")
                    ])
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-50",
                      attrs: {
                        src: require("../../assets/images/documentation/production/portage/creationPortage.png"),
                        alt: "Illustration création portage"
                      }
                    })
                  ]),
                  _c("p", [
                    _vm._v(
                      " Il faut renseigner les informations du lieu de portage, son nom, son adresse ainsi que ses jours d'ouvertures."
                    ),
                    _c("br"),
                    _vm._v(
                      " Le nombre d'effectifs à livrer doit être défini pour chaque structure / service / régime et texture."
                    ),
                    _c("br"),
                    _vm._v(
                      " L'option \"Plat témoin\" permet d'ajouter un effectif au total du lieu du portage."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      " Il est possible de définir les barquettes utilisables pour le portage des recettes :"
                    ),
                    _c("br"),
                    _c("ul", [
                      _c("li", [
                        _vm._v(
                          " De facon générale sur le lieu de portage, on peut définir les barquettes qui seront utilisées pour calculer le portage pour l'ensemble des structures / régimes et textures. "
                        )
                      ]),
                      _c("li", [
                        _vm._v(
                          " Ou alors sur chaque structure, cette configuration sera utilisée en prioritée si existante. "
                        )
                      ])
                    ]),
                    _vm._v(
                      " Si aucune configuration de barquette n'est choisie sur le lieu ou sur les structures du lieu, ce sera la configuration définie sur la structure de menu qui sera utilisée pour calculer le nombre de barquettes."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      " L'option \"Séparation du BL\" permet de séparer par régime et texture le nombre d'effectifs sur chaque recette dans le bon de livraison."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      ' Il est possible de rendre le lieu de portage "inactif", il ne sera donc pas pris en compte dans les calculs de livraisons. '
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      " La modification d'un lieu de portage se fait via la même fenêtre, à partir du bouton "
                    ),
                    _c("button", { staticClass: "btn btn-primary" }, [
                      _vm._v("Ouvrir")
                    ])
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionBarquettage" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Gestion des barquettes")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      " Ici, Vous pouvez gérer pour votre établissement les barquettes que vous utilisez."
                    ),
                    _c("br"),
                    _vm._v(
                      " Une barquette est définie par sa désignation et le nombre de portion qu'elle peut contenir."
                    ),
                    _c("br")
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/production/barquettage/listeBarquette.png"),
                        alt: "Illustration liste barquette"
                      }
                    })
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionCreationBarquette" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Ajout/Modification d'une barquette")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      " Pour créer une nouvelle barquette, il suffit de cliquer sur le bouton "
                    ),
                    _c("button", { staticClass: "btn btn-primary" }, [
                      _vm._v("Ajouter une barquette")
                    ]),
                    _c("br"),
                    _vm._v(
                      " Toutes les barquettes actives de cette liste seront visibles sur les pages Structures de menu et lieu de portage. "
                    )
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-50",
                      attrs: {
                        src: require("../../assets/images/documentation/production/barquettage/creationBarquette.png"),
                        alt: "Illustration création barquette"
                      }
                    })
                  ]),
                  _c("p", [
                    _vm._v(
                      " Il faut renseigner la désignation ainsi que le nombre de portions de la barquette."
                    ),
                    _c("br"),
                    _vm._v(
                      " Il est possible de rendre une barquette inactive, dans ce cas elle ne sera pas prise en compte dans les calculs de production/livraison."
                    ),
                    _c("br")
                  ]),
                  _c("p", [
                    _vm._v(
                      " La modification d'une barquette se fait via la même fenêtre, à partir du bouton "
                    ),
                    _c("button", { staticClass: "btn btn-primary" }, [
                      _vm._v("Ouvrir")
                    ])
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionArchive" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Archive")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      "Une fois votre production réalisée, utilisez le bouton numéro 3 pour archiver votre production."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      'Dans le menu "Production", vous avez la possibilité de consulter vos productions clôturées dans le sous-menu "Archive"'
                    )
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/production/archive/archiveProduction.png"),
                        alt: "Illustration archive production"
                      }
                    })
                  ]),
                  _c("p", [
                    _vm._v(
                      "Vous pouvez également télécharger les documents suivants :"
                    )
                  ]),
                  _c("ul", { staticClass: "puces" }, [
                    _c("li", [_vm._v("La fiche de production")]),
                    _c("li", [_vm._v("La fiche de sortie")]),
                    _c("li", [_vm._v("Le bon de livraison")])
                  ])
                ])
              ])
            ]
          )
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }